import { useMemo } from 'react'

import { useMercadoPago } from '@pages/Checkout/hooks/Payment/Mercadopago/useMercadoPago'

export const useMercadoPagoMethods = () => {
  const mp = useMercadoPago()

  return useMemo(() => ({ mp }), [mp])
}
